export const GOOGLE_CLIENT_ID =
  '538037217959-b5ffp2ufqpff27ele0o8rbvjdlvhvv9d.apps.googleusercontent.com'

// export const GOOGLE_OAUTH_URL = 'https://www.googleapis.com/oauth2/v3/userinfo'
